var React = require('react');

function Mail (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"mail","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"},React.createElement("path",{"d":"M1.802 2.646L11 9.085l9.198-6.44A1.258 1.258 0 0019 1.75H3c-.563 0-1.044.38-1.198.896zM1.75 4.44V15c0 .686.564 1.25 1.25 1.25h16c.686 0 1.25-.564 1.25-1.25V4.44l-8.82 6.174a.75.75 0 01-.86 0L1.75 4.44zm20-1.452V15A2.756 2.756 0 0119 17.75H3A2.756 2.756 0 01.25 15V2.988A2.756 2.756 0 013 .25h16a2.756 2.756 0 012.75 2.738z","transform":"translate(1 3)","fill":"#000","fillRule":"nonzero","id":"Combined-Shape"})));
}

Mail.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Mail;

Mail.default = Mail;
